module.exports = __webpack_public_path__ + "assets/binoculars-bc92b37f02aa895ea0deb0767096563f.svg";